






































import { defineComponent, PropType, ref } from '@vue/composition-api'

import HLine from '@/components/atoms/HLine.vue'
import DateGroup from '@/components/organisms/h/item/date/DateGroup.vue'
import ItemHierarchyGroup from '@/components/organisms/h/item/hierarchy/ItemHierarchyGroup.vue'
import ExtractConditionLayout from '@/components/organisms/h/layout/ExtractConditionLayout.vue'
import {
  promoSalesReduceExtractCondition,
  dateGroupExtractCondition,
  itemHierarchyGroupExtractCondition,
  itemHierarchyUseList,
  dateRange,
} from '@/types/entities'

export default defineComponent({
  components: {
    ExtractConditionLayout,
    DateGroup,
    ItemHierarchyGroup,
    HLine,
  },
  props: {
    defaultDateValue: {
      type: Array as PropType<string[]>,
      default: () => ['', ''],
    },
  },
  setup(props, context) {
    const TanaUseList = ref<itemHierarchyUseList>([
      ['Shobunrui', 'Class', 'Category', 'StoreShelve'],
    ])
    const itemStoreUseList = ref<itemHierarchyUseList>([
      ['StoreShelve', 'Store', 'Shobunrui', 'Tanpin'],
    ])
    const extractConditionOfDate = ref<dateGroupExtractCondition>({})
    const extractConditionOfTana = ref<itemHierarchyGroupExtractCondition>({})
    const extractConditionOfItemStore = ref<itemHierarchyGroupExtractCondition>(
      {}
    )
    const whereValidData = ref<string[]>(props.defaultDateValue)

    const changeExtractCondition = () => {
      const base: promoSalesReduceExtractCondition = {
        validData: ['', ''],
        storeShelve: [],
        storeShelveCount: 0,
        store: [],
        storeCount: 0,
        shobunrui: [],
        shobunruiCount: 0,
        class: [],
        classCount: 0,
        category: [],
        categoryCount: 0,
        tanpin: [],
        tanpinCount: 0,
        selectedRadio: '',
      }
      const date = {
        validData:
          extractConditionOfDate.value.dateRange ||
          (props.defaultDateValue as dateRange),
      }
      const tana = {
        shobunrui: extractConditionOfTana.value.shobunrui || [],
        shobunruiCount: extractConditionOfTana.value.shobunruiCount || 0,
        class: extractConditionOfTana.value.class || [],
        classCount: extractConditionOfTana.value.classCount || 0,
        category: extractConditionOfTana.value.category || [],
        categoryCount: extractConditionOfTana.value.categoryCount || 0,
        storeShelve: extractConditionOfTana.value.storeShelve || [],
        storeShelveCount: extractConditionOfTana.value.storeShelveCount || 0,
        selectedRadio: selectedRadio.value || '',
      }
      const itemStore = {
        storeShelve: extractConditionOfItemStore.value.storeShelve || [],
        storeShelveCount:
          extractConditionOfItemStore.value.storeShelveCount || 0,
        store: extractConditionOfItemStore.value.store || [],
        storeCount: extractConditionOfItemStore.value.storeCount || 0,
        shobunrui: extractConditionOfItemStore.value.shobunrui || [],
        shobunruiCount: extractConditionOfItemStore.value.shobunruiCount || 0,
        tanpin: extractConditionOfItemStore.value.tanpin || [],
        tanpinCount: extractConditionOfItemStore.value.tanpinCount || 0,
        selectedRadio: selectedRadio.value || '',
      }
      let cond = { ...base, ...date }
      switch (selectedRadio.value) {
        case 'Tana':
          cond = { ...cond, ...tana }
          break
        case 'ItemStore':
          cond = { ...cond, ...itemStore }
          break
        default:
          break
      }
      whereValidData.value = date.validData
      context.emit('change-extract-condition', cond)
    }

    const changeExtractConditionOfDate = (
      params: dateGroupExtractCondition
    ) => {
      extractConditionOfDate.value = params
      changeExtractCondition()
    }
    const changeExtractConditionOfItemStore = (
      params: itemHierarchyGroupExtractCondition
    ) => {
      extractConditionOfItemStore.value = params
      changeExtractCondition()
    }
    const changeExtractConditionOfTana = (
      params: itemHierarchyGroupExtractCondition
    ) => {
      extractConditionOfTana.value = params
      changeExtractCondition()
    }

    const changeRadio = (selected: string) => {
      selectedRadio.value = selected
      changeExtractCondition()
    }
    const selectedRadio = ref<string>('')
    const disabledByRadio = (name: string) => {
      return name !== selectedRadio.value
    }

    const requiredItemInput = [
      '有効日：常に入力',
      '棚での絞り込みの場合：小分類・クラス・カテゴリ・棚パターンのいずれかを一つ以上入力',
      '商品・店舗での絞り込みの場合：絞り込み項目のいずれかを一つ以上入力',
    ]
    const areaType = ['2']
    return {
      areaType,
      requiredItemInput,
      TanaUseList,
      itemStoreUseList,
      whereValidData,
      changeExtractConditionOfDate,
      changeExtractConditionOfTana,
      changeExtractConditionOfItemStore,
      changeRadio,
      disabledByRadio,
    }
  },
})
